import {
    FunFactCard,
    FunFactSectionContainer,
    FunFactsStyledSwiper,
} from "./FunFacts.styles";
import { SwiperSlide } from "swiper/swiper-react";
import { Autoplay, EffectFade } from "swiper/modules";
import { CommentAvatarGrid } from "../../Comment/Comment.styles";
import { CheckGPTLogoIcon } from "@icons/CheckGPTLogoIcon";

export type FunFactType = string;

export function FunFactsSection({
    funFacts,
}: {
    funFacts: FunFactType[] | undefined;
}) {
    const funFactsCount = funFacts?.length;
    if (!funFactsCount) {
        return null;
    }

    return (
        <FunFactSectionContainer>
            <CommentAvatarGrid style={{ marginRight: "12px" }}>
                <CheckGPTLogoIcon />
            </CommentAvatarGrid>
            {funFactsCount === 1 ? (
                <FunFactCard>{funFacts[0]}</FunFactCard>
            ) : (
                <FunFactsStyledSwiper
                    modules={[Autoplay, EffectFade]}
                    autoplay={{ delay: 8000 }}
                    loop={true}
                    effect="fade"
                    autoHeight={true}
                    allowTouchMove={false}
                    simulateTouch={false}
                    keyboard={{ enabled: false }}
                >
                    {funFacts.map((fact, index) => (
                        <SwiperSlide key={index}>
                            <FunFactCard>{fact}</FunFactCard>
                        </SwiperSlide>
                    ))}
                </FunFactsStyledSwiper>
            )}
        </FunFactSectionContainer>
    );
}
